import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import AssociationForm from '../../components/forms/equipment-association-form';
import { formSchema } from '../../components/forms/equipment-association-schema';
import { useStandardItem } from './standard-item-provider';
import { determineUpdatableFields } from '../../components/forms/association-specification-fields';

const StandardAssociationAdd = () => {
  const { addEquipmentAssociation, standardItem, multipleOptions } =
    useStandardItem();

  const {
    formState: { errors },
    handleSubmit,
    control,
    register,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    reValidateMode: 'onChange',
  });

  const [equipmentCodeId, setEquipmentCodeId] = useState('');
  const onSubmit = (data) => {
    const updatableFields = determineUpdatableFields(data);
    addEquipmentAssociation({
      variables: {
        equipmentAssociation: {
          ...updatableFields,
          standardItemId: Number(standardItem?.id),
          equipmentCodeId: Number(equipmentCodeId),
        },
      },
    });
  };

  return (
    // form id must exist in order to trigger submit from outside form
    <form
      id="equipment-code-add-form"
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <AssociationForm
        control={control}
        errors={errors}
        register={register}
        setValue={setValue}
        updateEquipmentCodeId={(id) => {
          setEquipmentCodeId(id);
        }}
        equipmentCodeId={equipmentCodeId}
        multipleOptions={multipleOptions}
        programName={standardItem?.program}
      />
    </form>
  );
};

export default StandardAssociationAdd;
